module.exports = __webpack_public_path__ + "img/acca-powered.99ca0ca9.png";